// RiskCategory Page - Uses generic module initialization patterns
// Demonstrates the streamlined approach for creating module pages

import { createModulePage } from '../../../components/generic/createModulePage';
import { initializeModule } from '../../../utils/configInit';
import { riskCategoryConfig } from './riskCategoryConfig';
import { createRiskCategoryValidation } from './riskCategoryValidation';
// RiskCategoryService no longer needed - using SWR hooks directly

/**
 * Initialize the riskCategory module using generic utilities
 * This pattern eliminates the need for separate initialization files
 */
const { config: initializedConfig } = initializeModule(
  riskCategoryConfig,
  createRiskCategoryValidation
);

/**
 * Create the RiskCategoryPage using the generic module page factory
 * This eliminates the need for custom component wrappers
 */
const RiskCategoryPage = createModulePage(
  initializedConfig,
  {
    displayName: 'RiskCategoryPage',
    description: 'Risk Category Management System - Manage risk categories for risk assessment classification'
  }
);

export default RiskCategoryPage;
